<mat-button-toggle-group
    aria-label="Font Style"
    class="button-toggle-square"
    name="fontStyle"
    [disabled]="disabled"
    [multiple]="multiple"
    [value]="value"
    (change)="onToggleButtonChange($event)"
>
    <mat-button-toggle
        *ngFor="let item of items"
        class="mat-button-toggle-button"
        disableRipple
        [value]="item.value"
        [matTooltip]="item.label"
        [matTooltipDisabled]="disabled"
    >
        <mat-icon id="icon">{{ item.matIcon }}</mat-icon>
    </mat-button-toggle>
</mat-button-toggle-group>
